export default "__VITE_ASSET__BW5ttTrn__"